export default {
  container: {
    width: ['0.5rem', null, null, '1rem'],
    borderTopLeftRadius: ['0.25rem', null, null, '0.5rem'],
    borderBottomLeftRadius: ['0.25rem', null, null, '0.5rem'],
  },
};
